const colors = {
  dark: "#000000",
  yellow: "#F2CC61",
  purple: "#B897F6",
  white: "#FFFFFF",
};

export default colors;
